import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { useRequestData } from 'wsm-common-data';
import { useSearchResultCount } from '../hooks/useSearchResultCount';
import '../global-sass/main.scss';

// SearchResultCount - Integrated with ws-locations-data

const SearchResultCount = ({
	isApiReady,
	sessionToken,
	resetSession,
	selectedPlaceId,
	onLocationStatusChange
}) => {
	const { locationCountString, isHidden, locationLabel } =
		useSearchResultCount({
			isApiReady,
			sessionToken,
			resetSession,
			selectedPlaceId,
			onLocationStatusChange
		});

	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';

	const locationCountClassNames = setClassNames([
		'location-count',
		'text-body',
		isHidden ? 'visibility-hidden' : '',
		isMobile ? 'text-nowrap' : ''
	]);

	return (
		<h3
			className={locationCountClassNames}
		>{`${locationCountString} ${locationLabel}`}</h3>
	);
};

SearchResultCount.propTypes = {
	isApiReady: PropTypes.bool,
	sessionToken: PropTypes.string,
	resetSession: PropTypes.func,
	selectedPlaceId: PropTypes.string,
	onLocationStatusChange: PropTypes.func
};

export default SearchResultCount;
